import { BoxProps } from '@chakra-ui/react'
import { Box, Icon } from '@chakra-ui/react'
import { ConditionalValue } from '@chakra-ui/react'
import { X } from 'lucide-react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import {
  MangoCloseButtonVariant,
  useMangoCloseButtonStyles,
} from '~/components/shared/componentStyles/MangoCloseButton.style'
import { Size } from '~/types/ThemeTypes'

type MangoCloseButtonProps = Omit<BoxProps, 'onClick'> & {
  onClick?: () => void
  variant?: MangoCloseButtonVariant
  size?: ConditionalValue<Size.sm | Size.md | Size.lg>
  'aria-label'?: string
}

export const MangoCloseButton = React.forwardRef<
  HTMLButtonElement,
  MangoCloseButtonProps
>((props: MangoCloseButtonProps, ref) => {
  const { t } = useTranslation()
  const {
    onClick,
    variant = MangoCloseButtonVariant.Primary,
    size,
    'aria-label': ariaLabel = t('global.close', 'Close'),
    ...rest
  } = props
  const styles = useMangoCloseButtonStyles({ variant, size })
  return (
    <Box asChild {...rest} css={styles.closeButton}>
      <button ref={ref} type="button" aria-label={ariaLabel} onClick={onClick}>
        <Icon css={styles.closeButtonIcon} as={X} aria-hidden />
      </button>
    </Box>
  )
})
